import { createElementVNode as _createElementVNode, vModelText as _vModelText, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "splash-container" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h1", { class: "text-white" }, "Forgot Email/Resend Confirmation", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "lead text-white" }, "Please enter your SSN and Date of Birth to retrieve your email address", -1)
const _hoisted_4 = { class: "form-group" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  for: "ssn",
  class: "form-label text-white"
}, "Social Security Number", -1)
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("label", {
  for: "dateOfBirth",
  class: "form-label text-white"
}, "Date of Birth", -1)
const _hoisted_8 = { class: "mt-3" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode("Retrieve Email Address")
const _hoisted_10 = {
  key: 0,
  class: "text-center"
}
const _hoisted_11 = {
  key: 0,
  class: "alert alert-success rounded mt-3 text-start",
  role: "alert"
}
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" An email was sent to the following email address(es) associated with the specified Social Security Number and Date of Birth, which contains a link to confirm the associated email if it has not yet been confirmed. ")
const _hoisted_13 = {
  key: 1,
  class: "alert alert-danger rounded lead mt-4",
  role: "alert"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_activity_button = _resolveComponent("activity-button")!
  const _directive_maska = _resolveDirective("maska")!

  return (_openBlock(), _createElementBlock("form", _hoisted_1, [
    _hoisted_2,
    _hoisted_3,
    _createElementVNode("div", _hoisted_4, [
      _hoisted_5,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_ctx.model.ssn = $event)),
        class: "form-control"
      }, null, 512), [
        [_vModelText, _ctx.model.ssn],
        [_directive_maska, '###-##-####']
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _hoisted_7,
      _withDirectives(_createElementVNode("input", {
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.model.dateOfBirth = $event)),
        type: "date",
        class: "form-control"
      }, null, 512), [
        [_vModelText, _ctx.model.dateOfBirth]
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_activity_button, {
        label: "Retrieve Email Address",
        class: "btn-primary",
        disabled: !_ctx.canSubmit(),
        clickHandler: _ctx.getEmails
      }, {
        default: _withCtx(() => [
          _hoisted_9
        ]),
        _: 1
      }, 8, ["disabled", "clickHandler"])
    ]),
    (_ctx.model.submitted)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          (_ctx.model.success && _ctx.model.emails && _ctx.model.emails.length > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _hoisted_12,
                _createElementVNode("ul", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.model.emails, (e) => {
                    return (_openBlock(), _createElementBlock("li", { key: e }, _toDisplayString(e), 1))
                  }), 128))
                ])
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_13, " An error occurred while attempting to retrieve the email address associated with the specified SSN and Date of Birth. "))
        ]))
      : _createCommentVNode("", true)
  ]))
}